// if ($(window).outerWidth() < 767) {
//   $('.product-bar')
// }

const onPageWithProductBarScroll = () => {
  if (!$(".product-bar").length) return;

  if ($(window).outerWidth() < 1280) {
    if ($("#description-product-detail").offset().top - $(window).scrollTop() < 100) {
      $(".product-bar").addClass("is--visible");
      // $('.header').hide();
    } else {
      $(".product-bar").removeClass("is--visible");
      // $('.header').show();
    }
  } else {
    if ($(".product-buy-card").offset().top + $(".product-buy-card").outerHeight() - $(window).scrollTop() < 100) {
      $(".product-bar").addClass("is--visible");
      $(".header").hide();
    } else {
      $(".product-bar").removeClass("is--visible");
      $(".header").show();
    }
  }
};

const onProductBarLinkClick = (e) => {
  const $target = $(e.currentTarget);
  e.preventDefault();

  let name;

  if ($target.find("a").length) {
    name = $target.find("a").attr("href");
  } else if ($target.attr("data-tab")) {
    name = $target.attr("data-tab");
  } else return;

  $([document.documentElement, document.body]).animate(
    {
      scrollTop: $(`.tab-content__elem[data-tab="${name}"]`).offset().top - 130,
    },
    400
  );
};

$(document).on("click", ".product-info__desc-link", onProductBarLinkClick);

$(window).on("scroll", onPageWithProductBarScroll);
$(document).on("click", ".product-bar__link", onProductBarLinkClick);
$(document).on("click", ".tab-list__elem", onProductBarLinkClick);
$(window).on("resize", function () {
  if ($(".product-bar").length && $(window).outerWidth() < 1280) $(".header").show();
});

$(window).on("load", function () {
  const navDataItems = [];

  const getNavItemArea = ($item) => {
    const elH = $item.outerHeight();
    const H = $(window).height();
    const r = $item[0].getBoundingClientRect();
    const t = r.top;
    const b = r.bottom;
    return Math.max(0, t > 0 ? Math.min(elH, H - t) : Math.min(b, H));
  };

  const getNameOfMaxNavItem = () => {
    const sorted = navDataItems.sort((a, b) => b.space - a.space)[0];
    return sorted ? sorted.name : "";
  };

  const setNavItemActive = () => {
    $(".product-bar__link a").removeClass("active");

    const currentMax = getNameOfMaxNavItem();

    if (currentMax === 0) return;

    const link = $(".product-bar__link").find(`a[href="${currentMax}"]`);
    link.addClass("active");
    // globalSwiperStorage['.nav-panel__slider-mobile'].swipers[0].slideTo(link.index())
  };

  $(".product-bar__link a").each((idx, item) => {
    const name = $(item).attr("href");

    const target = $(`.tab-content-list [data-tab="${name}"]`);

    if (target.length) {
      navDataItems.push({
        name: name,
        space: getNavItemArea(target),
      });
    }
  });

  setNavItemActive();

  const onNavPanelPageScroll = debounce(function () {
    navDataItems.forEach((item) => {
      item.space = getNavItemArea($(`.tab-content-list [data-tab="${item.name}"]`));
    });

    setNavItemActive();
  }, 0);

  $(window).on("scroll", function (e) {
    // const vw = $(window).outerWidth()
    // const delta = vw > 1279 ? 94 : vw > 767 ? 80 : 64 * (vw / 360)
    // const top = $('.nav-panel').offset().top + $('.nav-panel').outerHeight() - $(window).scrollTop() - delta

    // if (top < 0) {
    //   $('.nav-panel__mobile').addClass('is--visible')
    // } else {
    //   $('.nav-panel__mobile').removeClass('is--visible')
    // }

    onNavPanelPageScroll();
  });
});
